module.exports = __webpack_public_path__ + "img/level_0_img_3.0628bc54.jpeg";